import { stylesFieldForms } from '../styles'

export function formularioRegraTransformacaoApIO() {
  return {
    styles: stylesFieldForms
  }
}
export type FormularioRegraTransformacaoApiIO = ReturnType<typeof formularioRegraTransformacaoApIO>
